// extracted by mini-css-extract-plugin
export var drawerPaper = "_2l-0";
export var itemCard = "_2l-1";
export var itemImage = "_2l-2";